<template>
	<li>
		<a ref="linkEl" :href="`#${link.id}`">
			{{ link.label }}
		</a>
		<LoanApplicationFormNavigationLinks
			v-if="link.children"
			:links="link.children"
		/>
	</li>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import type { LinkType } from "./LinkType";
import { showFormField } from "@/helpers/application-form/navigation";

defineProps<{
	link: LinkType;
}>();

const linkEl = ref<HTMLElement | null>(null);

onMounted(() => {
	if (linkEl.value) {
		linkEl.value.addEventListener("click", (e) => {
			const id = linkEl.value?.getAttribute("href")?.slice(1);
			if (!id) {
				return;
			}

			const el = document.getElementById(id);
			if (el) {
				e.preventDefault();
				showFormField(el.id, true);
			}
		});
	}
});
</script>

<style scoped>
li {
	font-weight: 600;
}

li li a {
	padding-left: 1rem;
	font-weight: normal;
}

a {
	color: var(--text-muted);
	text-decoration: none;
	padding: 0.25rem 0;
	cursor: pointer;
	display: block;
	border-radius: 4px;

	&:hover {
		color: var(--text-primary);
		text-decoration: underline;
	}

	&.active {
		color: var(--accent-primary);
		background: var(--accent-primary-background);
	}
}
</style>
